import { useEffect, useState } from 'react';

export const useInitialLoading = (isLoading: boolean = true) => {
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    if (initialLoading) {
      if (isLoading) {
        return;
      }

      setInitialLoading(false);
    }
  }, [initialLoading, isLoading, setInitialLoading]);

  return { initialLoading };
};
